// extracted by mini-css-extract-plugin
module.exports = {"share__wrapper":"styles_share__wrapper__2WRT7","megaphone":"styles_megaphone__2HLLF","circle":"styles_circle__1REgS"};